'use strict';

const mapState = require('vuex').mapState;

const PickupPointPicker = require('./pickup-point-picker.vue');

const SERVICE_BOXBERRY = 'boxberry';

module.exports = {
    computed: {
        ...mapState('delivery', {
            selectedMethod: state => state.deliveryMethods.find(method => method.selected),
        }),
        isBoxberryPickupPointMethodSelected() {
            return this.selectedMethod && this.selectedMethod.service === SERVICE_BOXBERRY;
        }
    },
    methods: {
        showBoxberryPickupPointModal() {
            window.eventBus.$emit('shouldOpenModal', {
                content: PickupPointPicker,
                store: this.$store,
                modalLarge: true,
                centerOnMobile: true,
                customClass: 'boxberry-widget-wrapper'
            });
        },
        isBoxberryPickupPointMethod(method) {
            return method && method.service === SERVICE_BOXBERRY;
        }
    }
};
